// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import bankPichinchaSrc from './bank-pichincha.svg';
import bankSanaSanaSrc from './bank-sana-sana.svg';
import bankGuayaquilSrc from './bank-guayaquil.svg';
import bankMiVecinoSrc from './bank-mi-vecino.svg';
import bankFarmaciasCruzAzulSrc from './farmacias-cruz-azul.png';

export function BankIcons(): Node {
  return (
    <Root>
      <Icon src={bankPichinchaSrc} alt="banco pichincha" />
      <Icon src={bankSanaSanaSrc} alt="farmacias sanasana" />
      <Icon src={bankGuayaquilSrc} alt="banco quayaguil" />
      <Icon src={bankMiVecinoSrc} alt="pichincha mivecino" />
      <Icon src={bankFarmaciasCruzAzulSrc} alt="farmacias cruz azul" />
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
`;

const Icon = styled.img`
  margin: 10px 5px;
  max-width: 100px;
`;
